var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g2, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstantProcess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 660,
    viewBox: "0 0 640 660",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6128_38189)"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 130.166,
    y1: 20,
    x2: 130.166,
    y2: 554,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 257.389,
    y1: 20,
    x2: 257.389,
    y2: 554,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 384.611,
    y1: 20,
    x2: 384.611,
    y2: 554,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 511.834,
    y1: 20,
    x2: 511.834,
    y2: 554,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 110,
    x2: 20,
    y2: 110,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 348.52,
    x2: 20,
    y2: 348.52,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 229.26,
    x2: 20,
    y2: 229.26,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 467.78,
    x2: 20,
    y2: 467.78,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_6128_38189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599.596 351.643C626.676 367.297 626.82 392.698 599.915 408.352L369.784 542.257C342.88 557.911 299.111 557.911 272.031 542.257L40.4123 408.352C13.3323 392.698 13.1725 367.313 40.0766 351.659L270.208 217.738C297.112 202.084 340.897 202.084 367.977 217.738L599.596 351.627V351.643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.596 351.643C626.676 367.297 626.82 392.698 599.915 408.352L369.784 542.257C342.88 557.911 299.111 557.911 272.031 542.257L40.4123 408.352C13.3323 392.698 13.1725 367.313 40.0766 351.659L270.208 217.738C297.112 202.084 340.897 202.084 367.977 217.738L599.596 351.627V351.643Z",
    stroke: "#DDEFFF",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6128_38189)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M420.836 433.998C417.875 433.998 415.129 433.353 412.988 432.099L308.301 371.427C305.304 369.672 303.557 366.878 303.557 363.762C303.557 360.359 305.59 357.243 309.157 355.202L311.76 353.698C314.436 352.157 317.788 351.298 321.177 351.298C324.138 351.298 326.848 351.943 329.024 353.196L433.712 413.869C436.708 415.624 438.456 418.418 438.456 421.534C438.456 424.936 436.423 428.052 432.856 430.094L430.252 431.598C427.577 433.138 424.224 433.998 420.836 433.998Z",
    fill: "#BECEE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.515 423.754C242.385 429.628 225.87 429.592 215.669 423.683C205.467 417.773 205.396 408.21 215.562 402.336C225.692 396.462 242.206 396.498 252.408 402.408C262.609 408.318 262.68 417.88 252.515 423.754Z",
    fill: "#BECEE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M423.904 388.045L417.84 390.588C422.548 388.618 425.937 383.604 426.793 376.333L432.856 373.791C432 381.061 428.612 386.076 423.904 388.045Z",
    fill: "#71A4F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M337.799 56.7093L343.863 54.1663C347.715 52.5546 352.423 52.9486 357.31 55.7781L351.246 58.321C346.359 55.4915 341.651 55.0976 337.799 56.7093Z",
    fill: "#71A4F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M376.536 66.9526L376.786 70.0686L373.361 68.1704L373.504 70.0328L376.536 66.9526Z",
    fill: "#C2D8FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M419.945 100.083L413.881 102.626C412.418 103.235 410.635 103.055 408.852 102.017L414.915 99.4739C416.734 100.513 418.518 100.692 419.945 100.083Z",
    fill: "#71A4F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M422.834 96.7518L423.726 94.2805L428.184 101.766L428.719 100.262L422.834 96.7518Z",
    fill: "#C2D8FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M434.818 114.445L419.338 105.491L419.873 104.022C417.768 109.932 412.382 111.759 406.746 108.535L375.001 90.1257C369.401 86.8665 365.085 79.3809 364.515 71.9311L364.657 73.7935L349.177 64.8395C341.009 60.0759 333.411 64.3739 332.234 74.4024L305.304 307.351C304.127 317.38 309.87 329.342 318.038 334.106L403.679 383.747C411.847 388.511 419.445 384.213 420.622 374.184L447.552 141.236C448.729 131.207 442.986 119.209 434.818 114.481V114.445Z",
    fill: "url(#paint0_linear_6128_38189)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M351.246 58.3568L357.31 55.7781L376.535 66.9527L370.472 69.4957L351.246 58.3568Z",
    fill: "#71A4F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M370.472 69.4956L376.535 66.9526L376.785 70.0687L370.721 72.6116L370.472 69.4956Z",
    fill: "#71A4F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M370.722 72.6118L376.785 70.0688C377.106 74.5817 379.746 79.0945 383.134 81.0644L377.071 83.6074C373.682 81.6375 371.043 77.0888 370.722 72.6118Z",
    fill: "#71A4F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M377.07 83.643L383.134 81.0642L414.879 99.4738L408.816 102.053L377.07 83.643Z",
    fill: "#71A4F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M417.661 96.8235L423.725 94.2805L442.95 105.419L436.887 107.998L417.661 96.8235Z",
    fill: "#71A4F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M453.723 143.385L459.787 140.842L432.857 373.79L426.793 376.369L453.723 143.385Z",
    fill: "#71A4F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M436.887 107.998L417.662 96.8593L416.77 99.3306C415.486 102.876 412.24 104.023 408.816 102.053L377.07 83.6431C373.682 81.6732 371.042 77.1246 370.721 72.6475L370.472 69.4957L351.246 58.3568C340.403 52.0532 330.38 57.7122 328.846 71L301.916 303.949C300.383 317.201 307.944 333.067 318.788 339.335L404.428 388.977C415.272 395.28 425.295 389.585 426.828 376.333L453.758 143.385C455.292 130.097 447.73 114.266 436.887 107.962V107.998ZM420.586 374.185C419.445 384.213 411.848 388.475 403.644 383.747L318.003 334.106C309.799 329.378 304.092 317.38 305.269 307.351L332.199 74.4025C333.341 64.374 340.938 60.1118 349.142 64.8396L364.622 73.7936L364.693 73.722C365.763 80.5271 369.83 87.1173 374.966 90.09L406.711 108.5C411.883 111.508 416.877 110.147 419.267 105.312V105.491L434.747 114.445C442.915 119.173 448.658 131.171 447.481 141.2L420.551 374.149L420.586 374.185Z",
    fill: "url(#paint1_linear_6128_38189)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M436.887 107.998L442.95 105.455C453.794 111.723 461.356 127.59 459.822 140.877L453.758 143.42C455.292 130.132 447.73 114.302 436.887 107.998Z",
    fill: "#71A4F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M437.172 146.895C444.02 150.87 448.8 160.863 447.837 169.244L427.078 348.862C426.115 357.243 419.766 360.789 412.917 356.849L329.809 308.676C322.96 304.701 318.181 294.708 319.144 286.327L339.903 106.709C340.866 98.3277 347.215 94.746 354.064 98.7216L437.136 146.895H437.172Z",
    fill: "#A5C5F9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M188.346 251.048C183.71 252.409 182.069 254.809 180.927 251.227C179.786 247.645 179.822 245.926 180.392 242.237C180.963 238.548 186.527 219.458 186.527 216.163C186.527 212.868 185.279 207.782 185.422 206.242C185.564 204.702 187.669 201.514 189.024 200.834C190.38 200.153 194.553 198.541 195.552 198.362C196.55 198.183 196.55 198.864 196.55 198.864C196.55 198.864 198.69 198.649 198.797 199.473C198.904 200.296 198.441 201.622 198.441 201.622L195.445 202.911C195.445 202.911 194.41 205.812 193.732 206.815C193.055 207.818 192.484 210.11 192.591 211.077C192.698 212.044 192.234 217.703 192.234 217.703L188.56 245.461L188.346 251.012V251.048Z",
    fill: "#FF9C78"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M193.447 204.881C193.305 204.236 193.661 202.911 192.877 202.732C192.092 202.589 191.058 202.983 191.022 204.2C191.022 205.418 190.808 207.352 190.808 207.352C190.808 207.352 189.738 209.895 189.56 210.289C189.345 210.683 188.24 212.402 189.488 214.48C190.737 216.557 191.593 217.023 192.77 215.984C193.911 214.945 194.196 212.08 194.196 212.08L193.483 204.809L193.447 204.881Z",
    fill: "#FF9C78"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M192.912 199.974C192.912 199.974 188.845 203.377 188.168 204.917C187.49 206.457 189.059 210.755 190.665 211.113C192.27 211.471 192.341 204.2 193.554 203.162C194.766 202.123 192.947 199.974 192.947 199.974H192.912Z",
    fill: "#FF9C78"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M200.331 375.51C197.584 381.849 194.802 388.189 192.056 394.528L198.262 377.444C199.332 376.907 200.01 376.226 200.331 375.51Z",
    fill: "#2D344C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M192.056 394.528L185.564 374.829C185.814 375.617 186.492 376.405 187.562 377.05C190.451 378.805 195.231 378.984 198.227 377.479L192.021 394.564L192.056 394.528Z",
    fill: "#2D344C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M205.967 343.132C204.148 353.733 202.328 364.335 200.545 374.936C200.367 375.868 199.618 376.763 198.298 377.444L202.542 346.964C204.576 345.925 205.717 344.564 205.967 343.132Z",
    fill: "#363D55"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M185.457 374.22C184.637 363.511 183.816 352.766 182.996 342.057C183.103 343.561 184.173 345.102 186.242 346.319C190.665 348.97 197.941 349.256 202.507 346.964L198.262 377.444C195.266 378.948 190.487 378.769 187.597 377.014C186.242 376.19 185.529 375.223 185.457 374.22Z",
    fill: "url(#paint2_linear_6128_38189)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M212.281 138.549L202.543 346.964C204.79 345.854 205.932 344.278 206.003 342.702L215.74 134.287C215.669 135.863 214.492 137.439 212.281 138.549Z",
    fill: "url(#paint3_linear_6128_38189)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M209.998 122.683C211.745 125.87 213.493 129.058 215.241 132.246C216.454 134.502 215.455 136.937 212.28 138.549L208.606 125.691C210.14 124.903 210.604 123.757 210.033 122.683H209.998Z",
    fill: "url(#paint4_linear_6128_38189)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M183.032 341.627L192.769 133.213C192.698 134.86 193.768 136.544 196.015 137.905C200.438 140.555 207.714 140.841 212.28 138.549L202.542 346.964C197.977 349.256 190.7 348.97 186.278 346.319C184.03 344.958 182.96 343.275 183.032 341.627Z",
    fill: "url(#paint5_linear_6128_38189)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M193.447 131.243C195.48 128.234 197.513 125.226 199.546 122.217C198.833 123.256 199.261 124.509 200.759 125.405C202.899 126.694 206.359 126.802 208.535 125.727L212.209 138.585C207.643 140.877 200.367 140.591 195.944 137.94C192.769 136.042 191.913 133.428 193.375 131.279L193.447 131.243Z",
    fill: "url(#paint6_linear_6128_38189)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M208.571 125.691C206.395 126.802 202.9 126.658 200.795 125.369C198.655 124.079 198.726 122.181 200.902 121.071C203.078 119.961 206.573 120.104 208.678 121.393C210.818 122.683 210.747 124.581 208.571 125.691Z",
    fill: "#52586C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M192.663 239.3C190.095 243.312 183.46 246.607 182.854 247.932C182.248 249.257 180.892 251.263 181.392 252.337C181.891 253.412 185.101 256.958 188.454 256.42C195.231 255.274 196.444 254.2 201.437 252.123C205.967 250.26 192.627 239.336 192.627 239.336L192.663 239.3Z",
    fill: "#FF9C78"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M212.066 225.475C205.468 225.081 203.613 226.084 198.048 232.173C192.484 238.262 190.558 239.945 190.059 241.521C189.559 243.097 190.059 251.012 198.441 253.125C206.823 255.203 217.238 237.08 217.238 237.08L212.066 225.475Z",
    fill: "#F8F7FB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M280.3 280.167C280.3 280.167 281.798 279.88 284.473 279.021C287.148 278.197 291.143 279.343 291.143 279.343C291.143 279.343 297.67 281.85 298.312 282.172C298.955 282.495 298.776 283.856 297.991 284.071C297.207 284.321 292.213 284.178 292.213 284.178C292.213 284.178 292.213 286.076 291.714 286.542C291.214 287.008 290.537 288.154 290.537 288.154C290.537 288.154 289.574 290.661 289.288 290.947C289.039 291.198 288.432 292.774 286.649 292.38C284.865 291.986 280.442 288.798 280.442 288.798L277.518 287.509L280.3 280.131V280.167Z",
    fill: "#FF9C78"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M248.876 406.849C248.876 406.849 245.38 408.246 245.166 410.072C244.952 411.863 245.024 413.439 245.166 414.084C245.309 414.728 248.519 417.056 251.943 416.519C256.152 415.875 258.471 413.654 258.471 413.654L259.862 411.72C259.862 411.72 263.393 410.61 265.105 410.61C266.817 410.61 272.382 407.673 274.415 403.804C276.484 399.936 273.737 397.178 273.416 396.892C273.095 396.57 248.876 406.885 248.876 406.885V406.849Z",
    fill: "#212430"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M198.512 400.223C198.512 400.223 195.551 401.942 194.945 402.837C194.338 403.733 193.625 407.422 193.126 409.499C192.626 411.612 196.942 413.367 200.259 413.833C203.612 414.299 208.927 417.665 211.174 417.988C213.421 418.346 218.771 416.985 220.163 413.833C221.554 410.681 219.735 408.89 219.735 408.89L212.208 407.529L210.068 403.661L198.476 400.187L198.512 400.223Z",
    fill: "#33374A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M248.092 397.931C248.092 397.931 246.308 401.835 246.058 403.84C245.809 405.846 246.058 410.001 246.237 410.61C246.451 411.218 249.411 413.726 252.8 412.83C256.331 411.935 257.151 410.466 259.042 409.535C259.934 409.105 260.897 408.747 261.967 408.568C265.355 407.995 271.633 406.347 273.595 401.405C275.557 396.462 272.311 394.743 272.311 394.743C272.311 394.743 271.276 393.848 267.21 394.277C263.144 394.743 253.549 395.746 253.549 395.746L248.092 397.895V397.931Z",
    fill: "#33374A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M214.919 282.531C211.602 295.174 211.102 303.519 212.208 311.864C213.314 320.209 216.31 331.133 215.418 337.759C214.527 344.385 213.35 350.295 213.635 352.336C213.92 354.342 232.86 347.967 232.86 347.967L238.995 317.738L234.608 285.647L214.919 282.531Z",
    fill: "#363C53"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M219.627 338.082C219.342 338.296 217.416 341.806 214.027 347.286C210.639 352.766 205.93 367.809 204.325 373.432C202.72 379.055 195.729 402.443 195.515 402.766C195.301 403.052 199.902 405.344 204.111 406.24C210.389 407.529 211.851 406.061 211.851 406.061C211.851 406.061 230.649 358.174 232.896 348.003C228.009 340.875 219.627 338.117 219.627 338.117V338.082Z",
    fill: "#363C53"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M225.37 288.082C225.548 288.476 221.232 302.838 221.732 312.688C222.231 322.537 227.617 326.334 233.217 329.271C238.817 332.172 239.209 357.386 240.707 363.404C242.206 369.421 254.69 366.735 257.008 366.018C259.291 365.302 260.896 355.058 260.896 355.058C260.896 355.058 261.681 326.441 258.399 311.47C255.082 296.499 248.483 283.748 248.483 283.748L225.334 288.082H225.37Z",
    fill: "#3B4157"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M214.634 287.258C212.886 291.735 213.1 296.212 213.992 298.146C215.026 300.439 222.41 305.954 233.966 306.313C246.7 306.671 254.94 302.05 253.584 296.356C252.229 290.625 249.91 288.369 249.91 288.369L214.634 287.258Z",
    fill: "#212430"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M250.374 306.456C250.374 306.456 249.91 300.259 248.483 293.705L251.123 293.132C252.585 299.901 253.049 305.99 253.049 306.277L250.338 306.492L250.374 306.456Z",
    fill: "#3B4157"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M232.326 309.93C232.326 309.679 231.72 303.555 232.005 296.642L234.716 296.75C234.431 303.447 235.001 309.572 235.037 309.643L232.326 309.93Z",
    fill: "#3B4157"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M215.561 304.02C215.561 303.77 215.383 297.645 216.167 290.768L218.843 291.091C218.094 297.752 218.236 303.913 218.236 303.949L215.525 304.02H215.561Z",
    fill: "#363C53"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M242.384 356.813C242.384 356.813 240.744 357.387 240.851 363.762C240.958 370.137 243.062 393.704 245.702 403.482C248.983 407.279 259.862 403.124 260.112 400.617C260.326 398.11 261.039 360.144 261.039 360.144V348.253L242.384 356.813Z",
    fill: "#3B4157"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M232.789 231.349C240.672 236.184 251.444 238.477 252.122 245.138C252.835 251.8 252.479 291.234 252.586 294.278C252.728 297.323 239.246 305.847 222.66 299.507C215.347 295.89 214.349 294.636 213.207 290.159C212.066 285.682 211.353 275.833 205.111 257.459C203.898 253.842 200.902 245.282 201.294 238.262C201.686 231.242 204.682 226.156 211.888 225.225C219.093 224.293 222.909 225.726 222.909 225.726L232.754 231.349H232.789Z",
    fill: "#EAEEF9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M222.73 212.76C222.873 213.369 222.088 220.067 220.269 222.968C218.2 226.299 217.13 226.585 217.023 227.445C216.916 228.305 217.63 230.848 223.087 231.922C228.544 232.961 235.928 233.104 235.928 233.104C235.928 233.104 236.712 227.982 237.889 227.588C239.031 227.194 243.204 228.878 244.702 226.979C246.2 225.081 250.124 215.59 250.124 215.59C250.124 215.59 253.191 200.547 251.729 197.503C250.267 194.494 238.104 201.586 238.104 201.586L222.766 212.796L222.73 212.76Z",
    fill: "#FF9C78"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M249.233 240.196C248.377 239.515 246.522 240.59 246.522 240.59C246.522 240.59 241.493 243.885 241.35 252.982C241.207 262.08 253.727 282.889 259.184 287.043C265.533 285.826 267.067 277.66 266.068 274.866C265.07 272.072 252.907 243.921 251.729 242.345C250.552 240.769 249.233 240.196 249.233 240.196Z",
    fill: "#F8F7FB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M281.192 279.45C284.866 280.31 284.259 283.856 283.724 286.47C283.082 289.622 280.514 289.909 280.514 289.909C280.514 289.909 264.606 291.341 259.22 287.043C260.504 280.095 263.892 274.687 266.211 275.331C268.529 275.976 277.018 279.128 281.227 279.415L281.192 279.45Z",
    fill: "#F8F7FB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M243.633 210.54C243.098 209.537 240.494 207.209 238.675 211.041C236.713 215.196 233.396 219.566 233.396 219.566C233.396 219.566 224.621 217.882 222.517 215.841C220.412 213.799 213.172 191.987 228.866 188.907C239.674 183.033 251.623 192.309 252.55 195.855C253.513 199.365 249.554 201.084 249.554 201.084V206.851C249.554 206.851 247.699 208.57 247.2 208.892C246.7 209.25 245.452 213.548 245.452 213.548L243.918 213.262L243.633 210.54Z",
    fill: "#553012"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M242.206 208.212C241.207 207.424 239.816 208.427 238.996 211.113C238.175 213.799 238.389 215.232 238.924 216.772C239.459 218.312 241.136 217.811 241.207 215.912C241.314 214.05 243.597 209.143 242.17 208.212H242.206Z",
    fill: "#FF9C78"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M236.927 229.021C229.936 228.663 223.551 227.911 221.483 226.514C219.414 225.117 219.664 224.114 220.27 222.932L220.876 221.75C220.876 221.75 219.985 221.571 218.986 222.789C217.987 224.007 216.418 226.944 216.097 228.233C215.776 229.523 215.348 231.672 221.732 233.319C228.117 234.967 237.284 235.182 238.853 234.465C238.818 232.03 236.927 229.021 236.927 229.021Z",
    fill: "#F8F7FB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M414.308 361.327L410.991 362.724C413.952 361.47 416.092 358.318 416.627 353.734L419.944 352.337C419.409 356.921 417.269 360.073 414.308 361.327Z",
    fill: "#E5E5E5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M335.159 102.554L338.476 101.157C340.902 100.119 343.898 100.405 346.966 102.196L343.648 103.593C340.581 101.802 337.585 101.551 335.159 102.554Z",
    fill: "#E5E5E5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M343.685 103.593L346.966 102.196L430.074 150.369L426.757 151.766L343.685 103.593Z",
    fill: "#E5E5E5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M437.422 174.115L440.703 172.718L419.944 352.337L416.627 353.734L437.422 174.115Z",
    fill: "#E5E5E5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M426.757 151.766L430.074 150.369C436.922 154.345 441.702 164.337 440.739 172.718L437.422 174.115C438.385 165.734 433.605 155.706 426.757 151.766Z",
    fill: "#E5E5E5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M426.757 151.766C433.605 155.741 438.385 165.734 437.422 174.115L416.663 353.733C415.7 362.114 409.351 365.66 402.502 361.72L319.394 313.548C312.545 309.572 307.766 299.579 308.729 291.198L329.488 111.58C330.451 103.199 336.8 99.6171 343.649 103.593L426.757 151.766Z",
    fill: "url(#paint7_linear_6128_38189)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6128_38189",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 350,
    y: 120,
    width: 66,
    height: 95
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M361.126 120.856L415.628 152.446L403.322 214.623L350.532 184.036L361.126 120.856Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6128_38189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.223 162.904C369.687 163.155 370.257 163.477 370.828 163.8C372.005 164.48 373.182 165.268 374.324 166.164C376.785 168.492 379.139 171.035 381.35 173.792L386.701 176.873C387.343 177.123 387.985 177.589 388.555 178.198C389.126 178.807 389.554 179.523 389.875 180.347C390.731 182.46 390.125 184.358 384.81 181.099C384.275 180.777 383.74 180.454 383.205 180.096C381.707 179.093 380.209 178.198 378.675 177.41C381.493 180.848 384.881 183.32 388.377 184.394C391.409 185.218 395.154 183.821 400.29 185.075C402.324 185.576 402.859 188.585 402.859 188.62C402.966 189.373 402.93 190.089 402.68 190.698C402.431 191.307 402.038 191.736 401.539 191.987C401.467 191.987 401.432 192.023 401.36 192.023L382.706 193.062C382.099 193.097 381.493 192.954 380.851 192.596C380.245 192.238 379.674 191.736 379.174 191.092L367.903 179.451L366.441 178.592L369.187 162.94L369.223 162.904ZM366.227 158.714L361.197 155.813C360.983 155.705 360.769 155.634 360.555 155.598C360.341 155.598 360.163 155.598 359.985 155.705C359.628 155.884 359.378 156.243 359.307 156.744L356.525 173.184C356.489 173.434 356.489 173.685 356.525 173.936C356.56 174.186 356.632 174.473 356.774 174.724C357.024 175.225 357.381 175.655 357.773 175.906L362.767 178.807C363.159 179.022 363.552 179.093 363.908 178.95H363.98C364.336 178.735 364.586 178.377 364.657 177.911L367.511 161.507C367.546 161.257 367.546 161.006 367.511 160.72C367.475 160.433 367.404 160.182 367.261 159.896C367.154 159.645 367.011 159.394 366.833 159.215C366.655 159 366.476 158.857 366.262 158.75L366.227 158.714ZM397.009 165.626C396.474 168.492 395.083 170.748 393.121 172.073C391.159 173.363 388.734 173.613 386.237 172.79C383.74 171.966 381.35 170.103 379.46 167.525C377.569 164.946 376.25 161.794 375.786 158.606C375.322 155.419 375.715 152.374 376.927 150.046C378.14 147.682 380.066 146.178 382.42 145.748C384.774 145.319 387.343 145.999 389.732 147.718C392.122 149.437 394.191 152.016 395.546 155.096C396.331 156.816 396.831 158.642 397.08 160.469C397.33 162.295 397.294 164.05 396.973 165.698L397.009 165.626ZM392.158 154.953L383.276 149.831L382.884 151.909L385.987 153.7C386.522 154.022 387.022 154.523 387.414 155.168C387.806 155.813 388.02 156.529 388.092 157.245L382.492 153.986L382.099 156.063L387.699 159.287C387.414 159.788 386.986 160.111 386.451 160.218C385.952 160.326 385.381 160.218 384.81 159.896L381.707 158.105L381.35 160.182L385.381 169.136L386.879 168.42L383.811 161.615L384.453 161.973C385.452 162.546 386.522 162.725 387.45 162.439C388.377 162.152 389.09 161.4 389.518 160.361L390.945 161.185L391.338 159.108L389.911 158.284C389.911 157.46 389.768 156.601 389.518 155.741L391.73 157.03L392.122 154.953H392.158Z",
    fill: "#71A4F5"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M401.04 338.368L349.819 308.677C349.248 308.354 348.749 308.677 348.678 309.321V309.429C348.571 310.109 348.963 310.933 349.534 311.255L400.754 340.947C401.325 341.269 401.824 340.947 401.896 340.302V340.195C402.003 339.514 401.61 338.691 401.04 338.368Z",
    fill: "#CFD8DB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M413.951 229.881L337.121 185.361C335.302 184.322 333.625 185.254 333.376 187.474C333.126 189.695 334.374 192.345 336.193 193.42L413.024 237.939C414.843 238.978 416.519 238.047 416.769 235.826C417.019 233.606 415.77 230.955 413.951 229.881Z",
    fill: "url(#paint8_linear_6128_38189)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M411.776 248.863L334.945 204.344C333.126 203.305 331.449 204.236 331.2 206.457C330.95 208.678 332.198 211.328 334.018 212.402L410.848 256.922C412.667 257.961 414.344 257.03 414.593 254.809C414.843 252.588 413.595 249.938 411.776 248.863Z",
    fill: "url(#paint9_linear_6128_38189)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M331.807 231.349L392.372 266.449C394.191 267.488 395.868 266.557 396.117 264.336C396.367 262.115 395.119 259.465 393.3 258.39L332.734 223.255C330.915 222.216 329.238 223.147 328.989 225.368C328.739 227.588 329.988 230.239 331.807 231.313V231.349Z",
    fill: "url(#paint10_linear_6128_38189)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M407.389 286.793L330.558 242.273C328.739 241.235 327.063 242.166 326.813 244.386C326.563 246.607 327.812 249.257 329.631 250.332L406.461 294.852C408.281 295.89 409.957 294.959 410.207 292.738C410.456 290.518 409.208 287.867 407.389 286.793Z",
    fill: "url(#paint11_linear_6128_38189)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M354.028 280.418C354.278 278.197 353.029 275.547 351.21 274.472L328.346 261.22C326.527 260.181 324.851 261.113 324.601 263.333C324.351 265.554 325.6 268.204 327.419 269.279L350.283 282.531C352.102 283.569 353.778 282.638 354.028 280.418Z",
    fill: "url(#paint12_linear_6128_38189)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M348.499 310.646L401.753 341.52L402.038 338.941L348.82 308.068L348.499 310.646Z",
    fill: "url(#paint13_linear_6128_38189)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M300.703 66.4157V46.5735C300.739 47.4331 301.309 48.2927 302.415 48.9374V68.7796C301.238 68.1349 300.703 67.2753 300.703 66.4157Z",
    fill: "#FFAF19"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M323.71 51.4446V71.2868C323.638 72.1106 323.103 72.9701 322.033 73.6148V53.7726C323.175 53.1279 323.71 52.3042 323.71 51.4446Z",
    fill: "#FFAF19"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M322.069 53.7725L322.033 73.6147L320.393 74.5817L320.464 54.7037L322.069 53.7725Z",
    fill: "#FFAF19"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M312.403 54.7037L312.367 74.5817L302.38 68.7795L302.416 48.9373L312.403 54.7037Z",
    fill: "#FFAF19"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M320.464 54.7039V74.5461C318.217 75.8354 314.614 75.8354 312.367 74.5461V54.7039C314.65 55.9932 318.253 55.9932 320.464 54.7039Z",
    fill: "#FFAF19"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M322.033 49.1164C324.244 50.4058 324.244 52.519 322.033 53.7726L320.392 54.7038C318.181 55.9932 314.578 55.9932 312.367 54.7038L302.379 48.9015C300.168 47.6122 300.168 45.5348 302.379 44.2454L304.02 43.3142C306.232 42.0248 309.834 42.0248 312.046 43.3142L322.033 49.1164Z",
    fill: "#FFE359"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M313.437 34.9331L312.259 34.2526C310.262 33.1065 308.193 32.9632 306.588 33.8945C304.983 34.8257 304.056 36.6881 304.056 38.9804V45.284C304.056 45.9645 305.019 46.5018 306.16 46.5018C307.337 46.5018 308.265 45.9645 308.265 45.284V38.9804C308.265 38.1566 308.479 37.691 308.693 37.5477C308.907 37.4403 309.442 37.4761 310.155 37.9059L311.332 38.5864C313.472 39.8041 315.327 43.0634 315.327 45.4989V51.8026C315.327 52.4831 316.29 53.0203 317.431 53.0203C318.609 53.0203 319.536 52.4831 319.536 51.8026V45.4989C319.536 41.5591 316.861 36.903 313.437 34.9331Z",
    fill: "#D7EBFF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M307.658 37.2971C306.802 37.7269 306.303 38.1925 306.303 40.8787V46.5019C307.408 46.466 308.265 45.9288 308.265 45.2841V38.9804C308.265 38.1567 308.479 37.6911 308.693 37.5478C308.907 37.4403 309.442 37.4762 310.155 37.906C310.155 37.906 308.514 36.8673 307.658 37.2971Z",
    fill: "#A7D1FF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M306.089 61.1506L305.411 66.4872L309.406 68.7794L309.014 65.3411L308.729 62.6549C309.442 62.5474 309.906 61.9385 309.906 60.8999C309.906 59.324 308.8 57.3899 307.409 56.6019C306.054 55.814 304.912 56.4587 304.912 58.0346C304.912 59.0732 305.376 60.2194 306.089 61.1506Z",
    fill: "#1D1466"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M304.912 58.0344C304.912 56.8166 305.554 56.172 306.482 56.2794C306.375 56.5301 306.303 56.8525 306.303 57.2106C306.303 58.2493 306.767 59.3954 307.48 60.3266L306.803 65.6633L309.228 67.0601L309.406 68.7793L305.411 66.487L306.089 61.1504C305.376 60.255 304.912 59.0731 304.912 58.0344Z",
    fill: "#9C6600"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M305.411 66.4872L309.37 68.8152L309.192 67.0961L306.802 65.6992L305.411 66.4872Z",
    fill: "#9C6600"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M307.444 60.3625L306.089 61.1505L305.411 66.4871L306.802 65.6992L307.444 60.3625Z",
    fill: "#9C6600"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M304.912 40.0547C305.091 47.3254 307.017 55.5989 310.762 63.7292C314.507 71.8595 319.501 78.6646 324.887 83.4998L331.557 97.9696L340.26 93.9223C351.745 88.5141 353.6 67.8481 344.362 47.791C335.159 27.7339 318.359 15.8787 306.874 21.3228L298.171 25.37L304.912 40.0547Z",
    fill: "url(#paint14_linear_6128_38189)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M335.658 51.8382C344.861 71.8953 343.042 92.5255 331.556 97.9696C320.071 103.378 303.271 91.5584 294.069 71.5013C284.866 51.4442 286.685 30.8141 298.17 25.37C309.656 19.9618 326.456 31.7811 335.658 51.8382Z",
    fill: "#EFF4F9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M331.735 53.7006C339.225 69.9612 337.727 86.7232 328.382 91.1286C319.072 95.534 305.447 85.8994 297.992 69.6388C290.502 53.3783 292 36.6163 301.345 32.2109C310.655 27.8055 324.28 37.44 331.735 53.7006Z",
    fill: "#00D158"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M313.829 77.1243L310.904 78.4853C310.904 78.4853 311.154 78.3421 311.297 78.2704L314.221 76.9094C314.221 76.9094 313.972 77.0527 313.829 77.1243Z",
    fill: "#C6C0D0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M296.887 51.086L299.812 49.725C300.81 49.2594 302.059 49.5459 303.236 50.3697C304.341 51.1576 305.412 52.4112 306.196 53.9871L303.271 55.3481C302.487 53.7722 301.417 52.5186 300.311 51.7307C299.098 50.8711 297.885 50.6204 296.887 51.086Z",
    fill: "#D3E1FC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M303.307 55.3481L306.231 53.9871L310.619 62.762L307.694 64.1231L303.307 55.3481Z",
    fill: "#D3E1FC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M326.492 67.9913L329.417 66.5945L314.222 76.9096L311.297 78.2706L326.492 67.9913Z",
    fill: "#D3E1FC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M320.32 55.5989L323.245 54.2379C324.244 53.7723 325.492 54.0588 326.705 54.8826L323.78 56.2436C322.567 55.384 321.319 55.1333 320.32 55.5989Z",
    fill: "#D3E1FC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M323.78 56.2436L326.705 54.8826C327.74 55.5989 328.738 56.7808 329.523 58.2493C331.306 61.616 331.271 65.3767 329.416 66.6303L326.491 67.9913C328.346 66.7377 328.382 63.0129 326.598 59.6103C325.813 58.1418 324.815 56.9957 323.78 56.2436Z",
    fill: "#D3E1FC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M323.781 56.2435C324.815 56.9598 325.814 58.1418 326.598 59.6102C328.382 62.977 328.346 66.7377 326.491 67.9912L311.297 78.3063C310.084 79.1301 308.443 78.8436 306.874 77.7333C305.59 76.802 304.341 75.3336 303.414 73.4711L296.351 59.3953C294.639 55.9928 294.818 52.3037 296.744 51.1934C297.778 50.5846 299.098 50.8711 300.346 51.7665C301.452 52.5544 302.522 53.808 303.307 55.3839L307.694 64.1589L320 55.7779C321.034 55.0616 322.425 55.3123 323.781 56.2435Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_6128_38189",
    x: -20.5,
    y: 185.498,
    width: 681,
    height: 489,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 80
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.792157 0 0 0 0 0.8 0 0 0 0 0.870588 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6128_38189"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6128_38189",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.701961 0 0 0 0 0.756863 0 0 0 0 0.866667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6128_38189"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6128_38189",
    result: "effect3_innerShadow_6128_38189"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6128_38189",
    x1: 455.078,
    y1: 361.076,
    x2: 296.767,
    y2: 87.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B7D1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2D8FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6128_38189",
    x1: 313.152,
    y1: 336.112,
    x2: 443.253,
    y2: 111.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#97BDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#D2E2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6128_38189",
    x1: 183.032,
    y1: 360.252,
    x2: 202.543,
    y2: 360.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#363D55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6128_38189",
    x1: 206.93,
    y1: 240.518,
    x2: 211.318,
    y2: 240.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#40475D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6128_38189",
    x1: 208.571,
    y1: 132.102,
    x2: 213.718,
    y2: 129.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#747988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#696F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4E5468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40465C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6128_38189",
    x1: 186.527,
    y1: 240.626,
    x2: 208.678,
    y2: 241.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4E5468"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6128_38189",
    x1: 195.409,
    y1: 127.804,
    x2: 212.708,
    y2: 137.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40465C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#5E6476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#777C8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6128_38189",
    x1: 308.622,
    y1: 232.639,
    x2: 437.529,
    y2: 232.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6128_38189",
    x1: 333.34,
    y1: 211.65,
    x2: 416.805,
    y2: 211.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6128_38189",
    x1: 331.164,
    y1: 230.633,
    x2: 414.629,
    y2: 230.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6128_38189",
    x1: 328.953,
    y1: 244.888,
    x2: 396.189,
    y2: 244.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6128_38189",
    x1: 326.777,
    y1: 268.562,
    x2: 410.242,
    y2: 268.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6128_38189",
    x1: 324.565,
    y1: 271.893,
    x2: 354.064,
    y2: 271.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6128_38189",
    x1: 348.499,
    y1: 324.794,
    x2: 402.038,
    y2: 324.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6128_38189",
    x1: 344.341,
    y1: 92.0271,
    x2: 310.618,
    y2: 19.6096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A7D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E3ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E0EBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#D9E7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CDE2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BBDAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D9FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6128_38189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 660,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6128_38189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280.015,
    height: 413.998,
    fill: "white",
    transform: "translate(180.004 20)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantProcess);
export default __webpack_public_path__ + "static/media/instant-process.a0db2cf1585531d978ae5576c1ac88eb.svg";
export { ForwardRef as ReactComponent };